import { createIcon } from '@chakra-ui/react'

export const StakingUpArrowIcon = createIcon({
  displayName: 'Staking Up',
  path: (
    <path
      d='M13 3L4 12L5.5975 13.5975L11.875 7.30875L11.8751 10.6965L6.76923 15.8025L8.36673 17.4L11.875 13.8805V21H14.125V13.8805L17.6445 17.3888L19.2308 15.8025L14.1251 10.6968L14.125 7.30875L20.4137 13.5863L22 12L13 3Z'
      fill='currentColor'
    />
  ),
  viewBox: '0 0 24 24',
})
